import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";

import RegisterStepOne from "./RegisterStepOne";
import RegisterLastStep from "./RegisterLastStep";
import { register } from "actions/auth";
import { login } from "actions/auth";
import { Link, useNavigate } from "react-router-dom";
import GoogleGIcon from "assets/icons/google-g-icon.png";
import { setShowVerifyEmail, showLogin } from "actions/ui_control";
const initialState = {
  username: "",
  email: "",
  password: "",
  confirmPassword: "",
  termsAndConditions: false,
};
function Register() {
  const [loading, setLoading] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [formState, setFormState] = useState(initialState);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = formValues => {
    const { username, email, password } = formValues;

    setLoading(true);
    dispatch(register(username, email, password)).then(() => {
      dispatch(login(email, password, false))
        .then(() => {
          dispatch(setShowVerifyEmail());
          navigate("/dashboard");
          // onLoginCallback();
        })
        .catch(err => {
          setError(err);
          setTimeout(() => setError(null), 5000);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  const showLoginFunc = () => {
    dispatch(showLogin());
  };
  return (
    <Container>
      {/* {!isFirstStep && (
        <i
          className="bi bi-arrow-left position-absolute back-arrow"
          style={{
            left: "0",
            top: "0",
            padding: "3.5px",
            cursor: "pointer",
            marginLeft: "10px",
            fontSize: "20px",
          }}
          onClick={() => {
            setIsFirstStep(true);
          }}
        ></i>
      )} */}
      <Row>
        {/* Header section */}
        <Col sm={12} className="modal-header px-2">
          <h2>Hello!</h2>
          <h3>Register to start</h3>
          <p className="mt-3 mb-0">
            Already have an account? <Link onClick={showLoginFunc}>Login</Link>
          </p>
        </Col>

        {/* Third-party section */}
        <Col sm={12} className="modal-third-party px-2">
          <img src={GoogleGIcon} alt="google-g-icon" />
        </Col>

        {/* Form section */}

        {/* First step */}
        <Col sm={12}>
          {isFirstStep && (
            <RegisterStepOne
              setIsFirstStep={setIsFirstStep}
              formState={formState}
              setFormState={setFormState}
            />
          )}
          {/* Last step. Show hide is handled inside the component */}
          <RegisterLastStep
            isFirstStep={isFirstStep}
            formState={formState}
            setFormState={setFormState}
            setIsFirstStep={setIsFirstStep}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Register;
